var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"48","d":"M112 184l144 144l144-144"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }